import Client from './KomodoClient';
import { PAGE_ALL, pagerRows } from './Resource';

// komodo ComboChoiceController (api/combo-choice) + the product lookups the item editor needs
// (MaterialController refer / refer-attr, SellPriceController agreement).
const enc = encodeURIComponent;

const queryPager = (query) =>
	Client.post('/api/combo-choice/query-pager', {
		...PAGE_ALL,
		...(query || {}),
	}).then(pagerRows);
const get = (pid) => Client.get(`/api/combo-choice/${enc(pid)}`);
const create = (dto) => Client.post('/api/combo-choice', dto);
const update = (pid, dto) => Client.put(`/api/combo-choice/${enc(pid)}`, dto);
const remove = (pid) => Client.del(`/api/combo-choice/${enc(pid)}`);

// SelectorInput(Material) typeahead: GeneralProviderDTO { code, identityCode, name, defaultMatInCode, stopFlag }.
// An empty searchText returns the first `count` products: what the selector lists as soon as it opens.
// `startIndex` pages through the rest (komodo virtualises the selector the same way).
const searchProducts = (searchText, deptCode, count = 20, startIndex = 0) =>
	Client.post('/api/material/provider/query-pager', {
		startIndex,
		count,
		searchText: searchText || '',
		deptCode: deptCode || '',
		filterInvalid: true,
		matchingRules: 0,
	}).then(pagerRows);
// MaterialReferInfoDTO: units, kind and flags (isColor, allowCustomeName) of one product by its identity code.
const productRefer = (identityCode) =>
	Client.get(`/api/material/refer-identity/${enc(identityCode)}`);
// ComponentUtility.MaterialAttributeSelect: MaterialReferAttrsInfoDTO.materialColors, one MaterialDTO per
// variant { matInCode, materialCode, colorCode, colorName, imagePath, stopFlag }.
const productVariants = (materialCode) =>
	Client.get(`/api/material/refer-attr/${enc(materialCode)}`).then(
		(info) => (info && info.materialColors) || []
	);

// MaterialComboChoiceTable.GetAgreementParam → sellprice/agreement: the normal retail price of each item
// (SellPriceOfferDTO.calcPrice, matched back by rowId).
const SALES_CHANNEL_WEB = 9; // SalesChannelEnum.Web
const SELL_OPERATE_RETAIL = 1; // SellOperateTypeEnum.Retail
const SELL_KIND_NORMAL = 1; // SellKindEnum.Normal
const today = () => {
	const d = new Date();
	const p = (n) => String(n).padStart(2, '0');
	return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T00:00:00`;
};
export const agreementRequest = (items) => ({
	cusCode: null,
	offerDate: today(),
	deptCode: null,
	saleChannelType: SALES_CHANNEL_WEB,
	priceID: null,
	operateType: SELL_OPERATE_RETAIL,
	items: (items || []).map((it, i) => ({
		rowId: it.rowId || i + 1,
		matInCode: it.matInCode,
		unitCode: it.unitCode,
		quantity: 1,
		unitRatio: Number(it.unitRatio) || 1,
		sellKind: SELL_KIND_NORMAL,
	})),
});
const agreementPrices = (items) =>
	Client.post('/api/sellprice/agreement/query-list', agreementRequest(items));

export default {
	queryPager,
	get,
	create,
	update,
	remove,
	searchProducts,
	productRefer,
	productVariants,
	agreementPrices,
};
